import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, canonicalPath, ogImage }) => {
  const baseUrl = 'https://onyxadetailing.com';
  const canonicalUrl = `${baseUrl}${canonicalPath}`;
  const defaultDescription = description || 'Professional paint correction, ceramic coating, and mobile detailing services throughout the NYC & Tri-State area.';
  const defaultImage = ogImage || 'https://customer-assets.emergentagent.com/job_mobile-detailing-11/artifacts/n9c26bxp_Untitled%20design.png';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={defaultDescription} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={defaultDescription} />
      <meta property="og:image" content={defaultImage} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={defaultDescription} />
      <meta property="twitter:image" content={defaultImage} />
    </Helmet>
  );
};

export default SEO;
